import { Pipe, PipeTransform } from '@angular/core';
import { ListItem } from './multiselect.model';

@Pipe({
    name: 'ng2ListFilter',
    pure: false,
    standalone: false
})
export class ListFilterPipe implements PipeTransform {
    transform(items: ListItem[], filter: ListItem, allowWildFilter: boolean = false): ListItem[] {
        if (!items || !filter) {
            return items;
        }
        return items.filter((item: ListItem) => this.applyFilter(item, filter, allowWildFilter));
    }

    applyFilter(item: ListItem, filter: ListItem, allowWildFilter: boolean): boolean {
        if (typeof item.text === 'number'){
            item.text = item.text + '';
        }
        if (allowWildFilter) {
            const itemText = item.text?.toLowerCase() || '';
            const filterText = filter.text?.toLowerCase() || '';

            // Split by space, comma, or newline
            const itemTokens = itemText.split(/[\s,\n]+/).filter(Boolean);
            const filterTokens = filterText.split(/[\s,\n]+/).filter(Boolean);

            return filterTokens.every((ft: any) =>
                itemTokens.some((it: any) => it.includes(ft))
            );
        }
        return !(filter.text && item.text && item.text.toLowerCase().indexOf(filter.text.toLowerCase()) === -1);
    }
}
